// extracted by mini-css-extract-plugin
module.exports = {"separator":"components_separator__OvaJG"};